import { Component, EventEmitter, Input, Output, TemplateRef, Type } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzModalComponent } from "ng-zorro-antd/modal";
import { UiButtonType } from "../button/models/button.models";
import { UiModalButtonOptions, UiModalModels, UiOnClickCallback, UiStyleObjectLike } from "./modal.models";

@Component({
  selector: "ui-modal",
  exportAs: "uiModal",
  templateUrl: "./modal.component.html",
  styleUrls: ["modal.component.less"],
})
export class UiModalComponent<T = NzSafeAny, R = NzSafeAny> extends NzModalComponent {
  @Input("uiMask") @InputBoolean() public nzMask?: boolean;
  @Input("uiMaskClosable") @InputBoolean() public nzMaskClosable?: boolean;
  @Input("uiCloseOnNavigation") @InputBoolean() public nzCloseOnNavigation?: boolean;
  @Input("uiVisible") @InputBoolean() public nzVisible = false;
  @Input("uiClosable") @InputBoolean() public nzClosable = true;
  @Input("uiOkLoading") @InputBoolean() public nzOkLoading = false;
  @Input("uiOkDisabled") @InputBoolean() public nzOkDisabled = false;
  @Input("uiCancelDisabled") @InputBoolean() public nzCancelDisabled = false;
  @Input("uiCancelLoading") @InputBoolean() public nzCancelLoading = false;
  @Input("uiKeyboard") @InputBoolean() public nzKeyboard = true;
  @Input("uiCentered") @InputBoolean() public nzCentered = false;
  @Input("uiContent") public nzContent?: string | TemplateRef<object> | Type<T>;
  @Input("uiComponentParams") public nzComponentParams?: T;
  @Input("uiFooter") public nzFooter?: string | TemplateRef<object> | Array<UiModalButtonOptions<T>> | null;
  @Input("uiZIndex") public nzZIndex = 1000;
  @Input("uiWidth") public nzWidth: number | string = 520;
  @Input("uiWrapClassName") public nzWrapClassName?: string;
  @Input("uiClassName") public nzClassName?: string;
  @Input("uiStyle") public nzStyle?: object;
  @Input("uiTitle") public nzTitle?: string | TemplateRef<object>;
  @Input("uiCloseIcon") public nzCloseIcon: string | TemplateRef<void> = "close";
  @Input("uiMaskStyle") public nzMaskStyle?: UiStyleObjectLike;
  @Input("uiBodyStyle") public nzBodyStyle?: UiStyleObjectLike;
  @Input("uiOkText") public nzOkText?: string | null;
  @Input("uiCancelText") public nzCancelText?: string | null;
  @Input("uiOkType") public nzOkType: UiButtonType = "primary";
  @Input("uiOkDanger") @InputBoolean() public nzOkDanger = false;
  @Input("uiIconType") public nzIconType = "question-circle"; // Confirm Modal ONLY
  @Input("uiType") public nzModalType: UiModalModels = "default";
  @Input("uiAutofocus") public nzAutofocus: "ok" | "cancel" | "auto" | null = "auto";

  // TODO(@from ng-zorro) Input will not be supported
  @Input("uiOnOk")
  @Output("uiOnOk")
  public nzOnOk: EventEmitter<T> | UiOnClickCallback<T> | NzSafeAny = new EventEmitter<T>();

  // TODO(@from ng-zorro) Input will not be supported
  @Input("uiOnCancel")
  @Output("uiOnCancel")
  public nzOnCancel: EventEmitter<T> | UiOnClickCallback<T> | NzSafeAny = new EventEmitter<T>();

  @Output("uiAfterOpen") public nzAfterOpen = new EventEmitter<void>();
  @Output("uiAfterClose") public nzAfterClose = new EventEmitter<R>();
  @Output("uiVisibleChange") public nzVisibleChange = new EventEmitter<boolean>();
}
